import React, { Component } from 'react';
import AOS from 'aos';

import rocket1 from "../img/rocket1.png";
import rocket2 from "../img/rocket2.png";
import rocket3 from "../img/rocket3.png";
import bus from "../img/bus.png";

class About extends Component {

  render() {
    AOS.init();
    return (
      <>
      <section className="strip buffer">
        <h1>Starlink Mission</h1>
        <button className="ui button join">Join Now</button>
      </section>

        <section className="rocket container">
          <div className="left-block">
            <div className="block">
              <h1 className="with-underline">FALCON9</h1>
              <p>
                Falcon 9 is a two-stage rocket designed and manufactured by SpaceX for
                the reliable and safe transport of satellites and the Dragon spacecraft
                into orbit
              </p>
            </div>
            <div className="block dragon">
              <h2 className="with-underline">DRAGON SPACECRAFT</h2>
              <div
                data-aos="fade-left"
                data-aos-duration="2300"
                >
                  <hr className="dragonHr" />
              </div>
              <p>
                Dragon carries cargo in the spacecraft’s pressurized capsule and
                unpressurized trunk, which can also accommodate secondary payloads. In
                the future, Dragon will carry astronauts in the pressurized capsule as
                well.
              </p>
              <button className="ui inverted grey button">LEARN MORE</button>
            </div>
            <div className="block composite">
              <h2 className="with-underline">COMPOSITE FAIRING</h2>
              <p>
                The payload fairing is for the delivery of satellites to destinations in
                low Earth orbit (LEO), geosynchronous transfer orbit (GTO) and beyond.
              </p>
              <button className="ui inverted grey button">LEARN MORE</button>
            </div>
          </div>

          <div className="rocket-body">
            <span className="first">
            <div data-aos="fade-down"
              data-aos-easing="linear"
              data-aos-duration="1500">
              <img
                src={rocket1} alt="rocket1" 
              />
            </div>
            </span>
            <span className="second">
            <div data-aos="fade-down"
                data-aos-easing="linear"
                data-aos-duration="1900">
              <img src={rocket2} alt="rocket2" />
          </div>
            </span>
            <span className="third">
            <div data-aos="fade-down"
                data-aos-easing="linear"
                data-aos-duration="2300">
                <img src={rocket3} alt="rocket3" />
            </div>
            </span>
          </div>

          <div className="right-block">
            <div className="floating-graphics">
              <img src={bus} alt="bus" />
            </div>
            <div className="block payload">
              <h2>PAYLOAD</h2>

              <div
                data-aos="fade-right"
                data-aos-duration="3000"
                >
                <hr className="payloadHr" />
              </div>

              <p>
                Falcon 9 delivers payloads to space aboard the Dragon spacecraft or
                inside a composite fairing.
              </p>
            </div>
            <div className="block second-stage">
              <h2 className="with-underline">SECOND STAGE</h2>
              <p>
                The second stage, powered by a single Merlin vacuum engine, delivers
                Falcon 9’s payload to the desired orbit. For maximum reliability, the
                second stage has redundant igniter systems.
              </p>
              <button className="ui inverted grey button">LEARN MORE</button>
            </div>

            <div className="block capacity">
              <div className="blockEng">
                <h4 className="with-underline">ENGINE</h4>
                <h6>9</h6>
              </div>

                <div
                data-aos="fade-right"
                data-aos-duration="2300"
                >
                  <hr className="abtHr" />
                </div>

              <div>
                <h4 className="with-underline">BURNTIME</h4>
                <h6>
                  162 <small>SEC</small>
                </h6>
              </div>
            </div>

          </div>
        </section>
      </>
    )
  }
}

export default About
